import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col card-main mr-4" }
const _hoisted_2 = { class: "flex flex-row items-center justify-end mt-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex flex-col text-left" }
const _hoisted_5 = { class: "flex flex-row items-start justify-between" }
const _hoisted_6 = { class: "flex flex-col text-sm text-gray-500 ml-16" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "bg-yellow-200 rounded p-2 w-52 text-center mt-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Dismissal in progress", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "flex flex-row items-center text-sm text-gray-500"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Entry date", -1)
const _hoisted_14 = {
  key: 0,
  class: "bg-background p-2 rounded"
}
const _hoisted_15 = {
  key: 4,
  class: "flex flex-row items-center text-sm text-gray-500"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Dismissal date", -1)
const _hoisted_17 = {
  key: 0,
  class: "bg-red-200 p-2 rounded"
}
const _hoisted_18 = { class: "flex flex-row justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_SearchInput)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Filter, {
        modelValue: _ctx.company,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company) = $event)),
        options: _ctx.filterCompanyOptions,
        name: "clients",
        class: "mr-2"
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_Filter, {
        modelValue: _ctx.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.status) = $event)),
        options: _ctx.filterStatusOptions,
        name: "status"
      }, null, 8, ["modelValue", "options"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : (_ctx.error)
        ? (_openBlock(), _createBlock(_component_ErrorState, { key: 1 }))
        : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talents, (talent, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "mt-4 w-full"
      }, [
        _createElementVNode("button", {
          onClick: ($event: any) => (_ctx.$router.push(`/talent/${talent.id}/timeline`)),
          class: "rounded p-2 hover:bg-background-secondary"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_UserCard, {
                firstName: talent.first_name,
                lastName: talent.last_name,
                position: talent.job_title,
                class: "w-80"
              }, null, 8, ["firstName", "lastName", "position"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (talent.company)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(talent.company.visible_name), 1))
                : _createCommentVNode("", true),
              (talent.salary)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " $" + _toDisplayString((talent.salary.biweekly / 100).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })) + " (MXN) ", 1))
                : _createCommentVNode("", true),
              (talent.status === 'dismissal_in_progress')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : (talent.status !== 'dismissed')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      (talent.entry_day)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_DateFormatter, {
                              date: talent.entry_day
                            }, null, 8, ["date"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      (talent.baja_fecha)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_DateFormatter, {
                              date: talent.baja_fecha
                            }, null, 8, ["date"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
            ])
          ])
        ], 8, _hoisted_3),
        _createVNode(_component_Divider, { marginY: "4" })
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        class: "btn-text",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/talent')))
      }, "See all")
    ])
  ]))
}